import { AccountMap } from '../../../models/AccountMap';
import { AccountMappingService } from '../../../services/AccountMappingService';
import { Component, OnInit } from '@angular/core';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { Global } from '../../global';
import {MatSnackBar} from '@angular/material';

@Component({
  selector: 'app-account-mapping',
  templateUrl: './account-mapping.component.html',
  styleUrls: ['./account-mapping.component.css']
})
export class AccountMappingComponent implements OnInit {

  ArrLabels: any;
  labels: any = {};

  GL_Masters: any;
  GL_Master_invoice: any;
  GL_Master_income: any;
  GL_Master_expence: any;

  GL_Childs: any;


  ArrAccountMaps: any;
  AccountMaps: any = {}

  AccMapStudentInv_CR: AccountMap ={
    component:'student-invoice',
    productName:'STIN',
    DRCR:'C',
    ChildAcc: '',
    MasterAcc: '',
    trnCode:'AAT'
  };
  AccMapStudentInv_DR: AccountMap={
    component:'student-invoice',
    productName:'STIN',
    DRCR:'D',
    ChildAcc: '',
    MasterAcc: '',
    trnCode:'AAT'
  };
  AccMapStudentInv_Discount: AccountMap={
    component:'student-invoice',
    productName:'STIN',
    DRCR:'D',
    ChildAcc: '',
    MasterAcc: '',
    trnCode:'ACT'
  };
  AccMapFixAsset_CR: AccountMap={
    component:'fix-assets',
    productName:'FIXI',
    DRCR:'C',
    ChildAcc: '',
    MasterAcc: '',
    trnCode:'AAT'
  };
  AccMapFixAsset_DR: AccountMap={
    component:'fix-assets',
    productName:'FIXI',
    DRCR:'D',
    ChildAcc: '',
    MasterAcc: '',
    trnCode:'AAT'
  };

  // Expense Entry Account Master
  AccMapExpenseAccMaster: AccountMap={
    component:'expense-entry',
    productName:'EXPS',
    DRCR:'D',
    ChildAcc: '',
    MasterAcc: '',
    trnCode:'AAT'
  };

  // Income gl child account
  StRecInvIncomeAcc: AccountMap={
    component:'student-invoice-clear',
    productName:'BILL',
    DRCR:'C',
    ChildAcc: '',
    MasterAcc: '',
    trnCode:'ACT'
  };

  // Bank master accounts
  BankAccounts: AccountMap={
    component:'student-invoice-clear',
    productName:'BILL',
    DRCR:'D',
    ChildAcc: '',
    MasterAcc: '',
    trnCode:'AAT'
  };

  // Debit account
  StInvoiceRecDRAcc: AccountMap={
    component:'student-invoice-clear',
    productName:'BILL',
    DRCR:'D',
    ChildAcc: '',
    MasterAcc: '',
    trnCode:'ACT'
  };

  // student master account
  // Debit account
  StudentRecInvoiceSettings: AccountMap={
    component:'student-invoice-clear',
    productName:'BILL',
    DRCR:'C',
    ChildAcc: '',
    MasterAcc: '',
    trnCode:'AAT'
  };

  fixedAssetCRAcc: any;
  selectedStInCRAc: any;

  constructor(
    private global:Global,
    private UtilityService: UtilityService,
    public snackBar: MatSnackBar,
    private GL_MasterService: GL_MasterService,
    private AccountMapService: AccountMappingService

  ) { }

  ngOnInit() {
    
    this.getGlMasters();
    this.getLabels();
    
    
    
  }

  getGlMasters() {
    this.GL_MasterService.getGL_Masters("All", 0)
      .subscribe(response => {
        if (response) {
          this.GL_Masters = response;          
          this.getGls();
          
        }
      },
        error => console.log("error --> " + error))


    this.GL_MasterService.getGL_Masters("Expenses",0)
      .subscribe(response => {
        if (response) {
          //this.GL_MastersDR = response;
        }
      },
        error => console.log("error --> " + error))
  }

  getGlChild() {
    this.GL_MasterService.getGL_Masters("All",0)
      .subscribe(response => {
        if (response) {
          this.GL_Masters = response;
        }
      },
        error => console.log("error --> " + error))


    this.GL_MasterService.getGL_Masters("Expenses" ,0 )
      .subscribe(response => {
        if (response) {
          //this.GL_MastersDR = response;
        }
      },
        error => console.log("error --> " + error))
  }

  getGls()
  {
    
    this.GL_MasterService.getAllChilds()
      .subscribe(response => {
        if (response) {
          this.GL_Childs = response;
           
          for (let i = 0; i < this.GL_Masters.length; i++) {
            this.GL_Masters[i].childs = this.GL_Childs.filter(f => f.gL_MasterCode == this.GL_Masters[i].gL_Code);
          }          
          this.GL_Master_invoice = this.GL_Masters.filter(f => f.gL_CategoryID == 1 || f.gL_CategoryID == 3);
          this.GL_Master_expence = this.GL_Masters.filter(f => f.gL_CategoryID == 81);
          
          this.getAccountMaps();
        }
    },
    error => console.log("error --> " + error))

  }

  getAccountMaps()
  {
    this.AccountMapService.getAccountMapping('ALL')
      .subscribe(response => {
        if (response){
          this.ArrAccountMaps = response;
          console.log(response);
          this.setMaps();
        }
      },
      error => console.log("error --> " + error))
  }

  setMaps() {
    
    // fixed assets
    this.AccMapFixAsset_CR.ChildAcc = this.ArrAccountMaps.find( (o:any) => o.component === 'fix-assets' &&  o.drcr === 'C' ).childAcc;
    this.AccMapFixAsset_DR.MasterAcc = this.ArrAccountMaps.find( (o:any) => o.component === 'fix-assets' &&  o.drcr === 'D' ).masterAcc;

    // student invoice
    this.AccMapStudentInv_CR.ChildAcc = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice' &&  o.drcr === 'C' ).childAcc;
    this.AccMapStudentInv_DR.MasterAcc = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice' &&  o.drcr === 'D' && o.trnCode === 'AAT'  ).masterAcc;
    this.AccMapStudentInv_Discount.ChildAcc = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice' &&  o.drcr === 'D' && o.trnCode === 'ACT' ).childAcc;

    //student invoice recieve
    this.StRecInvIncomeAcc.ChildAcc = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice-clear' &&  o.drcr === 'C' && o.trnCode === 'ACT' ).childAcc;
    this.BankAccounts.MasterAcc = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice-clear' &&  o.drcr === 'D'  && o.trnCode === 'AAT' ).masterAcc;
    this.StudentRecInvoiceSettings.MasterAcc = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice-clear' &&  o.drcr === 'C'  && o.trnCode === 'AAT' ).masterAcc;
    this.StInvoiceRecDRAcc.ChildAcc = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice-clear' &&  o.drcr === 'D' && o.trnCode === 'ACT' ).childAcc;

    // Expense Entry
    this.AccMapExpenseAccMaster.MasterAcc = this.ArrAccountMaps.find( (o:any) => o.component === 'expense-entry' &&  o.drcr === 'D' && o.trnCode === 'AAT' ).masterAcc;

    console.log(this.AccMapStudentInv_CR.ChildAcc)
    console.log(this.AccMapStudentInv_DR.MasterAcc);
    console.log(this.AccMapStudentInv_Discount.ChildAcc);
    console.log(this.StRecInvIncomeAcc.ChildAcc);
    console.log(this.BankAccounts.MasterAcc);
    console.log(this.GL_Masters);
    console.log(this.StudentRecInvoiceSettings.MasterAcc);
  }


  submitStInvoice()
  {
    this.AccountMapService.updateAccountMap(this.AccMapStudentInv_CR)
      .subscribe(response => {
        
      })

      this.AccountMapService.updateAccountMap(this.AccMapStudentInv_DR)
      .subscribe(response => {
        
      })

      this.AccountMapService.updateAccountMap(this.AccMapStudentInv_Discount)
      .subscribe(response => {
        this.openSnackBar('ثبت شد','');
      })

  
  }

  submitStRecInvoice()
  {
    this.AccountMapService.updateAccountMap(this.StRecInvIncomeAcc)
    .subscribe(response => {
      
    })

    this.AccountMapService.updateAccountMap(this.BankAccounts)
    .subscribe(response => {
      
    })

    this.AccountMapService.updateAccountMap(this.StInvoiceRecDRAcc)
    .subscribe(response => {
      
    })

    this.AccountMapService.updateAccountMap(this.StudentRecInvoiceSettings)
    .subscribe(response => {
      this.openSnackBar('ثبت شد','');
    })
  }
  
  submitFixAssets()
  {
    this.AccountMapService.updateAccountMap(this.AccMapFixAsset_CR)
    .subscribe(response => {
      
    })

    this.AccountMapService.updateAccountMap(this.AccMapFixAsset_DR)
    .subscribe(response => {
      this.openSnackBar('ثبت شد','');
    })
  }

  submitExpenseSettings()
  {
    this.AccountMapService.updateAccountMap(this.AccMapExpenseAccMaster)
    .subscribe(response => {
      this.openSnackBar('ثبت شد','');
    })
  }
  openSnackBar(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 2000,
    });
    snackBarRef.closeWithAction = function() {
      snackBarRef.dismiss();
    }
  }

  getLabels(){
    this.UtilityService.getLabels('account-mapping',this.global.lang)
      .subscribe(response => {
          if(response){
              this.ArrLabels = response;
              this.setLabels();
          }
      },
      error => console.log(error))
    }

  setLabels(){
    //title
    this.labels['account-mapping-Title'] = this.ArrLabels.find( (o:any) => o.key === 'account-mapping-Title').value;

    // labels
    this.labels['StudentInvoiceSettings'] = this.ArrLabels.find( (o:any) => o.key === 'StudentInvoiceSettings').value;
    this.labels['FixAssetSettings'] = this.ArrLabels.find( (o:any) => o.key === 'FixAssetSettings').value;

    this.labels['StInvoiceCRAcc'] = this.ArrLabels.find( (o:any) => o.key === 'StInvoiceCRAcc').value;
    this.labels['FixAssetsCRAcc'] = this.ArrLabels.find( (o:any) => o.key === 'FixAssetsCRAcc').value;

    this.labels['StudentMasterAcc'] = this.ArrLabels.find( (o:any) => o.key === 'StudentMasterAcc').value;
    this.labels['FixAssetsMasterAcc'] = this.ArrLabels.find( (o:any) => o.key === 'FixAssetsMasterAcc').value;

    this.labels['StudentDiscountAccount'] = this.ArrLabels.find( (o:any) => o.key === 'StudentDiscountAccount').value;

    // Recive Incoice settings
   this.labels['StudentRecInvoiceSettings'] = this.ArrLabels.find( (o:any) => o.key === 'StudentRecInvoiceSettings').value;
   this.labels['StRecInvIncomeAcc'] = this.ArrLabels.find( (o:any) => o.key === 'StRecInvIncomeAcc').value;
   this.labels['BankAccounts'] = this.ArrLabels.find( (o:any) => o.key === 'BankAccounts').value;
   this.labels['StInvoiceRecDRAcc'] = this.ArrLabels.find( (o:any) => o.key === 'StInvoiceRecDRAcc').value;
    // Alerts
    this.labels['AccountMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'AccountMandatory').value;

    // Expense Entry
    this.labels['ExpenseMasterAcc'] = this.ArrLabels.find( (o:any) => o.key === 'ExpenseMasterAcc').value;
    this.labels['ExpenseSettings'] = this.ArrLabels.find( (o:any) => o.key === 'ExpenseSettings').value;
    
  }
 

}



// WEBPACK FOOTER //
// ./src/app/components/settings/account-mapping/account-mapping.component.ts